import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { environment } from './environments/environment';
import { enableProdMode } from '@angular/core';
import { DataEffects } from './app/storage/Lead/data.effects';
import { PlanesEffects } from './app/storage/Planes/planes.effects';
import { CotizacionEffects } from './app/storage/Cotizacion/cotizacion.effects';
import { provideHttpClient } from '@angular/common/http';


if (environment.production) {
  enableProdMode();
}

(function (w: any, d: Document, s: string, l: string, i: string) {
  w[l] = w[l] || [];
  w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
  const f = d.getElementsByTagName(s)[0] as HTMLElement;
  const j = d.createElement(s) as HTMLScriptElement;
  const dl = l !== 'dataLayer' ? '&l=' + l : '';
  j.async = true;
  j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
  f.parentNode!.insertBefore(j, f);
})(window, document, 'script', 'dataLayer', environment.gtmId);

bootstrapApplication(AppComponent, {
  providers: [
    provideHttpClient(),
    ...appConfig.providers
  ]
}).catch((err) => console.error(err));